import { render, staticRenderFns } from "./ControlSetup.vue?vue&type=template&id=ee331af0"
import script from "./ControlSetup.vue?vue&type=script&lang=ts"
export * from "./ControlSetup.vue?vue&type=script&lang=ts"
import style0 from "./ControlSetup.vue?vue&type=style&index=0&id=ee331af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports